/**
 * RedaAuth Config - DrMax E-shop
 * Konfigurace pro autentizaci
 */

import RedaAuth from '../lib/reda-auth.js';
import * as GA4 from './ga4-ecommerce.js';

// Inicializace RedaAuth s konfigurací pro DrMax
const auth = new RedaAuth({
    // Debug mode pro development
    debug: true, // PRODUCTION: nastavit na false

    // Routing parameters - přidáno ajax=1 pro REDA backend
    routing: {
        login: {
            io: null,
            aio: 'login',
            subio: null,
            additionalParams: {}
        },
        register: {
            io: 'registration',
            aio: null,
            subio: null,
            additionalParams: {
                ajax: '1'
            }
        },
        forgotPassword: {
            io: null,
            aio: 'forgotPassword',
            subio: null,
            additionalParams: {}
        }
    },

    // Features
    features: {
        useTabs: false,           // Používáme Bootstrap modaly
        useModals: true,
        useOTP: false,            // Zatím nepotřebujeme
        useAres: false,           // Zatím nepotřebujeme
        useDynamicLoading: false,
        autoHideAlerts: true,     // Auto-skrýt alerty po 5s
        rememberTab: false
    },

    // DOM selectors
    selectors: {
        // Forms
        loginForm: '#loginForm',
        registerForm: '#registerForm',
        forgotPasswordForm: '#forgotPasswordForm',

        // Alert container
        alertContainer: '#alertMessage',
        alertText: '#alertText',
        alertIcon: '#alertIcon',

        // Login fields
        loginUsername: '#username',
        loginPassword: '#password',

        // Register fields
        registerUsername: '#reg-username',
        registerPassword: '#reg-password',
        registerPasswordConfirm: '#confirm-password',
        registerEmail: '#reg-email',
        registerFirstname: '#firstname',
        registerLastname: '#lastname',
        registerPhone: '#phone',

        // Forgot password
        forgotEmail: '#forgot-email'
    },

    // Validační pravidla
    validation: {
        password: {
            minLength: 8,
            requireMatch: true
        },
        username: {
            minLength: 4
        }
    },

    // Callback funkce
    callbacks: {
        /**
         * Po úspěšném přihlášení
         */
        onLoginSuccess: (data) => {
            console.log('[AUTH] onLoginSuccess called, data:', data);

            // GA4 tracking
            try {
                console.log('[AUTH] Calling GA4.login()...');
                GA4.login('email');
                console.log('[AUTH] GA4.login() completed');
            } catch (error) {
                console.error('[AUTH] Error calling GA4.login():', error);
            }

            // Redirect na URL z backendu (nebo fallback na homepage)
            setTimeout(() => {
                console.log('[AUTH] Redirecting to:', data.redirect_url || '/index.php?tName=index-intro');
                window.location.href = data.redirect_url || '/index.php?tName=index-intro';
            }, 1000);
        },

        /**
         * Po úspěšné registraci
         */
        onRegisterSuccess: (data) => {
            // GA4 tracking
            GA4.signUp('email');

            // Zavřít modal po 2 sekundách
            setTimeout(() => {
                const modalEl = document.getElementById('registrationModal');
                if (modalEl && typeof bootstrap !== 'undefined' && bootstrap.Modal) {
                    const modal = bootstrap.Modal.getInstance(modalEl);
                    if (modal) modal.hide();
                }
            }, 2000);
        },

        /**
         * Po úspěšném odeslání zapomenutého hesla
         */
        onForgotPasswordSuccess: (data) => {
            // GA4 tracking
            GA4.passwordResetRequest('email');

            // Zavřít modal po 2 sekundách
            setTimeout(() => {
                const modalEl = document.getElementById('forgotPasswordModal');
                if (modalEl && typeof bootstrap !== 'undefined' && bootstrap.Modal) {
                    const modal = bootstrap.Modal.getInstance(modalEl);
                    if (modal) modal.hide();
                }
            }, 2000);
        }
    }
});

// Export pro globální přístup
window.redaAuth = auth;

export default auth;
